import { render } from "./SidebarRail.vue?vue&type=template&id=16c085b5&ts=true"
import script from "./SidebarRail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarRail.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarRail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "16c085b5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('16c085b5', __exports__)) {
    api.reload('16c085b5', __exports__)
  }
  
  module.hot.accept("./SidebarRail.vue?vue&type=template&id=16c085b5&ts=true", () => {
    api.rerender('16c085b5', render)
  })

}


export default __exports__